// Singleton-Store fuer die KRITISCHE Lane (nicht-quittierbare Fehler).
// Quelle: /v2-api/events?severity=critical&unacked=true -- offene Events
// der severity "critical" aus allen Domains (vault/hosts/storage/tasks).
//
// Diese Fehler sind NICHT wegklickbar; sie verschwinden nur, wenn die
// Ursache wirklich behoben ist (Auto-Ack ueber ein Recovery-Event bzw.
// AckOpenByEntity im jeweiligen Watchdog/Collector).
//
// Live-Weg (seit 02.11.2026): das Protokoll-Topic `meldung`
// (protokoll/meldungen.svelte.ts). Frueher musste zusaetzlich alle 30 s
// gepollt werden, weil ein Teil der Recovery-Pfade (Storage-Collector,
// Host-Checker) still per AckOpenByEntity ackte, ohne dass jemand es
// meldete. Seit der Beobachter in internal/audit JEDE gespeicherte
// Aenderung meldet (neu, aktualisiert, quittiert -- auch die direkten
// Schreiber), entfaellt der Poll; das Netz darunter ist der Revalidator.

import { SvelteMap } from "svelte/reactivity";
import { registerRevalidator } from "./revalidate.svelte";

import { clearPersisted } from "./persistent-summary.svelte";
import { betrifftListe, meldungRefetch } from "./protokoll/meldungen.svelte";

export interface CriticalEvent {
  id: number;
  ts: string;
  domain: string;
  type: string;
  entity?: string;
  summary: string;
  // remediation_cluster: vom Backend (?with_remediation=true) aufgelöstes
  // stummschaltbares Cluster -- speist die Maßnahmen-Affordance der Lane.
  remediation_cluster?: { cluster_id: string; cluster_name: string };
}

export interface CriticalSummary {
  count: number;
  events: CriticalEvent[];
}

const _summary = new SvelteMap<string, CriticalSummary>();
let _unsubscribe: (() => void) | undefined;
let _started = false;

async function refreshSummary(): Promise<void> {
  try {
    const r = await fetch(
      "/v2-api/events?severity=critical&unacked=true&limit=50&with_remediation=true",
      { credentials: "include" },
    );
    if (!r.ok) return;
    const events = (await r.json()) as CriticalEvent[];
    const s: CriticalSummary = { count: events.length, events };
    _summary.set("current", s);
  } catch {
    // ignore -- die naechste Meldung / Revalidierung holt es nach
  }
}

export function startCriticalSummaryStream(): void {
  if (_started) return;
  _started = true;
  registerRevalidator(refreshSummary);
  // Bewusst KEIN localStorage-SWR fuer die kritische Lane: ein gecachter
  // Alarm, dessen Ursache laengst behoben ist, wuerde bei jedem Reload
  // kurz als KRITISCH aufblitzen (transient-warning-Lektion). Lieber
  // 100 ms leer als ein falscher roter Banner; der Fetch ist seit den
  // 069-Indexen ohnehin einstellige Millisekunden. clearPersisted raeumt
  // den Alt-Key aus der SWR-Phase weg.
  clearPersisted("critical");
  // Erst hoeren, dann laden: was dazwischen geschaehe, ginge sonst verloren.
  // Jede gespeicherte Meldung kann eine kritische Lage oeffnen oder (per
  // Recovery-Event, als Quittierung) schliessen; neue Meldungen anderer
  // Schwere nicht.
  _unsubscribe = meldungRefetch(refreshSummary, { ms: 200, filter: betrifftListe({ schweren: ["critical"] }) });
  void refreshSummary();
}

export function stopCriticalSummaryStream(): void {
  _started = false;
  if (_unsubscribe) {
    _unsubscribe();
    _unsubscribe = undefined;
  }
  _summary.clear();
}

export function getCriticalSummary(): CriticalSummary | undefined {
  return _summary.get("current");
}
